function srpResultsNav(globalWindow) {
    const listingsFromStorage = globalWindow.sessionStorage.getItem('srp-np-listings');

    if (listingsFromStorage === null) {return;}

    const srpListingIds = JSON.parse(listingsFromStorage)[0].listingIds;
    const activeListingId = parseInt(globalWindow.location.pathname.split('/')[3]);
    const activeIdIndex = srpListingIds.indexOf(activeListingId);
    let getIndexArray;
    document.querySelector('.page-section--srp-results').classList.add('page-section--srp-results--active');

    if (activeIdIndex <= 3){
        getIndexArray = srpListingIds.splice(0,7).join(',');
    } else {
        const startIndex = activeIdIndex - 3;
        const endIndex = activeIdIndex + 4;
        getIndexArray = srpListingIds.slice(startIndex, endIndex).join(',');
    }
    getListings(getIndexArray);

    function getListings(listingsIdArray){
        const xhr = new XMLHttpRequest();
        xhr.open('GET', '/vehicledetail/detail/pagination/' + listingsIdArray + '/');
        xhr.setRequestHeader("Content-Type", '');
        /* istanbul ignore next */
        xhr.onload = () => loadXhr(xhr.status, xhr.response);
        xhr.send();
    }

    /* istanbul ignore next */
    function loadXhr(xhrStatus, xhrResponse){
        if (xhrStatus === 200) {
            const container = document.getElementById('SrpResults');
            const pathArray = globalWindow.location.pathname.split('/');
            container.innerHTML = xhrResponse;
            document.querySelector('[listingId="' + pathArray[3] + '"]').classList.add('srp-results__card--active');
        }
    }
}

export default srpResultsNav;
